import * as R from 'ramda';

import getFilters from '../../selectors/getSelectedFilters';
import sportsApi from '../../utils/sportsApi';
import { normalize, schema } from 'normalizr';
import getInsightsInfo from './getInsightsInfo';

const generateId = account => `${account.id}`;

const getAccounts = store => async (state, params = {}) => {
    try {
        const userClientId = state.user.selectedUserClientId;
        const clientId = state.user.selectedClientId;
        const filters = state.clients[userClientId].filters;

        // Sets filters as loading
        const loadingState = R.assocPath(
            ['clients', userClientId, 'accounts', 'isLoading'],
            true,
            state,
        );

        store.setState(loadingState);

        const accountSchema = new schema.Entity('accountsById', undefined, {
            idAttribute: generateId,
        });

        const globfilters = getFilters(filters);

        const { accountUsernames, audiencePlatforms } = globfilters;

        const endpoint = `/audience-insights`;
        let query = { ...params, clientId };

        if (accountUsernames && accountUsernames.length > 0) {
            query = { ...query, accountUsernames };
        }
        if (audiencePlatforms && audiencePlatforms.length > 0) {
            query = { ...query, platformIds: audiencePlatforms };
        }

        const accounts = await sportsApi
            .url(endpoint)
            .query(query)
            .get()
            .json();

        const newAccounts = accounts.map(account => {
            const { platformId, demographicInsights } = account;
            const getInfo = getInsightsInfo(platformId);

            const insights = demographicInsights.reduce(
                (acc, { demographicTypeName, demographicSegments }) => {
                    const data = getInfo({
                        demographicTypeName,
                        demographicSegments,
                    });

                    if (data && !R.isEmpty(data)) {
                        Object.keys(data).forEach(key => {
                            acc[key] = data[key];
                        });
                    }
                    return acc;
                },
                {},
            );

            return {
                ...account,
                insights,
                isAuthenticated: demographicInsights.length > 0,
            };
        });

        const changesId = filters.changesId;

        const { result, entities } = normalize(newAccounts, [accountSchema]);

        const order = result;
        const accountsById = entities.accountsById || {};

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            accounts: {
                                isLoading: R.F,
                                changesId: R.always(changesId),
                                byId: R.always(accountsById),
                                order: R.always(order),
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

export default getAccounts;
